import React from 'react';
import classNames from 'classnames';

import lang from '../../../lib/language';

import iconAdded from '../../../assets/img/icon-check-circle-dark.svg';
import iconAdd from '../../../assets/img/icon-plus-circle_24px.svg';
import { useIsMobile } from '../../../hooks';
import { ClickableDiv } from '../..';

import styles from './AddToWatchList.module.scss';

type Props = {
    isAdded?: boolean;
    isSearch?: boolean;
    onClick?: (e: any) => void;
}
const AddToWatchlistButton = ({ isAdded, isSearch, onClick } : Props): JSX.Element => {
  const { isMobile } = useIsMobile();
  return (
    <ClickableDiv
      onClick={onClick}
      className={classNames(
        { [styles.buttonContent]: !isMobile && !isSearch },
        { [styles.buttonContentMobile]: isMobile && !isSearch },
        { [styles.buttonContentSearchMobile]: isMobile && isSearch },
      )}
    >
      {
      isAdded
        ? <img src={iconAdded} alt="icon added" />
        : <img src={iconAdd} alt="icon add" />
      }

      {
      isMobile || isSearch
        ? null
        : <span>{isAdded ? lang.symbolDetailsAddedToWatchlist() : lang.symbolDetailsAddToWatchlist()}</span>
    }
    </ClickableDiv>
  );
};

export default AddToWatchlistButton;
